module.exports = __webpack_public_path__ + "img/wildlife_vet_splash.1dfe874e.jpg";